import { IVariantBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNodeHeaderBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  DEFAULT_ICON_RENDER_SIZE,
  SplitConfig,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config/index'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import {
  FlowChartSplitNode,
  FlowChartSplitNodeVariant,
} from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartSplitNode'
import { NodeType } from 'common/builder/constants/NodeType'
import { ISplitNode } from 'common/builder/nodes/nodeInterfaces'

export const SplitNodeGenericConverterRule: ConverterRule<
  ISplitNode,
  FlowChartSplitNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: ISplitNode) => entity?.nodeType === NodeType.SPLIT,
  convert: (entity, { blocks: blocksMap }) => {
    const blocks = entity.blocks.map((id) => blocksMap[id] as IVariantBlock)
    blocks.sort((blockA, blockB) => blockA.title.localeCompare(blockB.title))
    const variants: FlowChartSplitNodeVariant[] = blocks.map((block) => ({
      id: block.id,
      title: block.title,
      percent: block.percent,
      nextStep: new FlowChartNextStepBuilder(block.id || '').withColor(`#${block.color}`).build(),
    }))

    const icon = new FlowChartIconBuilder(SplitConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE)

    if (SplitConfig.iconColor) {
      icon.withColor(SplitConfig.iconColor)
    }

    const header = new FlowChartNodeHeaderBuilder(entity.caption)
      .withColor(SplitConfig.headerBackground)
      .withIcon(icon.build())
      .build()

    return {
      id: entity.id,
      onboardingElementId: '',
      type: FlowChartNodeType.SPLIT,
      nodeType: NodeType.SPLIT,
      data: {
        header,
        variants,
      },
    }
  },
}
